"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodPhotoIdScanStatusDocumentPurposeEnumToJSON = exports.PodPhotoIdScanStatusDocumentPurposeEnumFromJSONTyped = exports.PodPhotoIdScanStatusDocumentPurposeEnumFromJSON = exports.PodPhotoIdScanStatusDocumentPurposeEnum = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var PodPhotoIdScanStatusDocumentPurposeEnum;
(function (PodPhotoIdScanStatusDocumentPurposeEnum) {
    PodPhotoIdScanStatusDocumentPurposeEnum["PHOTOID"] = "PHOTO_ID";
    PodPhotoIdScanStatusDocumentPurposeEnum["CITIZENSHIP"] = "CITIZENSHIP";
})(PodPhotoIdScanStatusDocumentPurposeEnum = exports.PodPhotoIdScanStatusDocumentPurposeEnum || (exports.PodPhotoIdScanStatusDocumentPurposeEnum = {}));
function PodPhotoIdScanStatusDocumentPurposeEnumFromJSON(json) {
    return PodPhotoIdScanStatusDocumentPurposeEnumFromJSONTyped(json, false);
}
exports.PodPhotoIdScanStatusDocumentPurposeEnumFromJSON = PodPhotoIdScanStatusDocumentPurposeEnumFromJSON;
function PodPhotoIdScanStatusDocumentPurposeEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PodPhotoIdScanStatusDocumentPurposeEnumFromJSONTyped = PodPhotoIdScanStatusDocumentPurposeEnumFromJSONTyped;
function PodPhotoIdScanStatusDocumentPurposeEnumToJSON(value) {
    return value;
}
exports.PodPhotoIdScanStatusDocumentPurposeEnumToJSON = PodPhotoIdScanStatusDocumentPurposeEnumToJSON;
//# sourceMappingURL=PodPhotoIdScanStatusDocumentPurposeEnum.js.map